import { Navigate, Route, Routes } from "react-router";
import { useAuth } from "../auth/AuthContext";
import { AuthCallbackPage } from "../features/login/auth-callback-page";
import { LoginPage } from "../features/login/login-page";
import { ChatThreadPage } from "../features/chat/thread-reader-page";
import { DocumentViewerPage } from "../features/documents/document-viewer-page";
import { JournalDayPage } from "../features/journal/journal-day-page";
import { ProjectDetailPage } from "../features/projects/project-detail-page";
import { PromptEditorPage } from "../features/prompts/prompt-editor-page";
import { PromptsPage } from "../features/prompts/prompts-page";
import { TenantPromptEditorPage } from "../features/prompts/tenant-prompt-editor-page";
import { TenantPromptsPage } from "../features/prompts/tenant-prompts-page";
import { RunDetailPage } from "../features/runs/run-detail-page";
import { RunsPage } from "../features/runs/runs-page";
import { TenantDetailPage } from "../features/tenants/tenant-detail-page";
import { TenantOnboardingPage } from "../features/tenants/tenant-onboarding-page";
import { TenantsPage } from "../features/tenants/tenants-page";
import { Shell } from "./shell";

/** Everything but the sign-in pair lives behind the session. */
function Gate({ children }: { children: React.ReactNode }) {
  const { status } = useAuth();
  if (status === "loading") {
    return (
      <div className="flex h-screen items-center justify-center bg-chrome-deep">
        <p className="font-display text-[0.8rem] tracking-[0.1em] text-white/60 uppercase">
          Loading…
        </p>
      </div>
    );
  }
  if (status !== "authenticated") return <LoginPage />;
  return <>{children}</>;
}

export function AppRoutes() {
  return (
    <Routes>
      <Route path="/auth/callback" element={<AuthCallbackPage />} />
      <Route
        path="/*"
        element={
          <Gate>
            <Routes>
              <Route element={<Shell />}>
                <Route index element={<Navigate to="/tenants" replace />} />
                <Route path="tenants" element={<TenantsPage />} />
                <Route path="tenants/new" element={<TenantOnboardingPage />} />
                <Route path="tenants/:tenantId" element={<TenantDetailPage />} />
                <Route
                  path="tenants/:tenantId/projects/:projectId"
                  element={<ProjectDetailPage />}
                />
                <Route
                  path="tenants/:tenantId/projects/:projectId/documents/:docId"
                  element={<DocumentViewerPage />}
                />
                <Route
                  path="tenants/:tenantId/projects/:projectId/journal/:date"
                  element={<JournalDayPage />}
                />
                <Route
                  path="tenants/:tenantId/projects/:projectId/chat/:threadId"
                  element={<ChatThreadPage />}
                />
                <Route path="tenants/:tenantId/prompts" element={<TenantPromptsPage />} />
                <Route path="tenants/:tenantId/prompts/:slug" element={<TenantPromptEditorPage />} />
                <Route path="prompts" element={<PromptsPage />} />
                <Route path="prompts/:slug" element={<PromptEditorPage />} />
                <Route path="runs" element={<RunsPage />} />
                <Route path="runs/:tenantSlug/:runId" element={<RunDetailPage />} />
                <Route path="*" element={<Navigate to="/tenants" replace />} />
              </Route>
            </Routes>
          </Gate>
        }
      />
    </Routes>
  );
}
